<template src="./template.html"></template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import weighStationsApi from '@/api/weighStations.js'
import zonesApi from '@/api/zones'

export default {
  name: 'weighStationNew',
  inject: ['companyUser'],
  data() {
    return {
      weighStation: {},
      loading: true,
      zones: [],
      templateMode: 'new',
    }
  },
  components: { BreadCrumbs, CompanyNav, LoadingSpinner, SectionHeader },
  methods: {
    async submitWeighStation() {
      const result = await weighStationsApi.create(this.weighStation)

      if (result) this.$router.push({ name: 'weigh_stations' })
    },
  },
  async mounted() {
    this.weighStation.company_uuid = this.companyUser.company_uuid
    this.zones = await zonesApi.getAllForCompany(this.companyUser.company_uuid)
    this.loading = false
  },
}
</script>
